import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    productTypeList: Custom.productTypeLists,
    serviceTypeList: Custom.serviceTypeList,
    splCategoryList: Custom.splCategoryList,
    healthConditionList: Custom.healthConditionList,
    studentGenderList: Custom.studentGenderList,
    studyingClassList: Custom.studyingClassList,
    installmentList: Custom.installmentList,
    studentClassList: Custom.studentClassList,
    genderList: Custom.genderList,
    hospitalCategoryList: Custom.hospitalCategoryList,
    publicServiceStatus: Custom.publicServiceStatus,
    budgetProcessList: Custom.budgetProcessList,
    formTypeList: Custom.formTypeList,
    serviceNameList: [],
    hospitalCategoryInfoList: [],
    hospitalInfoList: [],
    diseaseList: Custom.diseaseList,
    qoutaList: Custom.qoutaList,
    budgetTypeList: Custom.budgetTypeList,
    applicationTypeList: Custom.applicationTypeList,
    expenseTypeList: Custom.expenseType,
    hospitalList: [],
    instituteList: [],
    userList: [],
    beneficiaryType: Custom.beneficiaryType,
    accountType: Custom.accountType,
    bankAccountType: Custom.bankAccountType,
    mfsAccountType: Custom.mfsAccountType,
    noticeStatusList: Custom.noticeStatusList,
    deliveryTypeList: Custom.deliveryTypeList,
    statusList: Custom.statusList,
    applicationToList: Custom.applicationToList,
    applicationStatusV2: Custom.applicationStatusV2,
    quarterList: Custom.quarterList,
    inspectionSurvey: Custom.inspectionSurvey,
    disabilityTypesList: [],
    mainProgramList: [],
    socialOrgTypeList: [],
    sdgNameList: []
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
